

import React, { useState, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';

function MForeignProfileForm() {
  // State to store the uploaded file names
  const [frontLicenseFileName, setFrontLicenseFileName] = useState(null);
  const [backLicenseFileName, setBackLicenseFileName] = useState(null);
  const [idFrontFileName, setIdFrontFileName] = useState(null);
  const [idBackFileName, setIdBackFileName] = useState(null);

  // Refs for the file inputs
  const frontLicenseRef = useRef(null);
  const backLicenseRef = useRef(null);
  const idFrontRef = useRef(null);
  const idBackRef = useRef(null);

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name; // Get the file name
      if (type === 'frontLicense') setFrontLicenseFileName(fileName);
      if (type === 'backLicense') setBackLicenseFileName(fileName);
      if (type === 'idFront') setIdFrontFileName(fileName);
      if (type === 'idBack') setIdBackFileName(fileName);
    }
  };

  return (
    <div className="w-full mx-auto rounded-lg">
      {/* Personal Information */}
      <h2 className="font-semibold text-lg mb-4 text-left">Personal Information</h2>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-left">Name as per DL*</label>
          <input type="text" placeholder="Ranjita" className="w-full border p-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-left">Email Address*</label>
          <input type="email" placeholder="ranjita@gmail.com" className="w-full border p-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-left">Date of Birth*</label>
          <input type="date" className="w-full border p-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-left">Your Gender*</label>
          <div className="flex items-center space-x-4">
            <label className="flex items-center space-x-2 text-left">
              <input type="radio" name="gender" value="Male" />
              <span>Male</span>
            </label>
            <label className="flex items-center space-x-2 text-left">
              <input type="radio" name="gender" value="Female" />
              <span>Female</span>
            </label>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-left">Location*</label>
          <input type="text" placeholder="null" className="w-full border p-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-left">Emergency Contact Number*</label>
          <input type="tel" placeholder="+91 8888888888" className="w-full border p-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-left">Blood Group*</label>
          <input type="text" placeholder="AB" className="w-full border p-2 rounded" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-left">GST No (optional)</label>
          <input type="text" placeholder="Enter GST number" className="w-full border p-2 rounded" />
        </div>
      </div>

      {/* Document Verification Section */}
      <h2 className="font-semibold text-lg mt-6 mb-4 text-left">Document Verification</h2>
      <ul className="list-disc list-inside text-sm text-gray-600 mb-6 text-left">
        <p>Please upload the following documents:</p>
        <li className="list-decimal"> Driving License/International Driving Permit</li>
        <li className="list-decimal"> Identification Proof</li>
        <li>Accepted forms of ID that can be uploaded are: Aadhaar Card, Passport.</li>
        <li>For bulk bookings, contact our support team.</li>
        <li>Ensure to upload pictures of original documents only.</li>
        <li>Learner license is not applicable for renting a vehicle with us.</li>
      </ul>

      {/* Upload Driving License Section */}
      <h2 className="font-semibold text-lg mt-6 mb-4 text-left">Upload Driving Licence</h2>
      <ul className="list-disc list-inside text-sm text-gray-600 mb-6 text-left">
        <li>Please upload both sides of your original driving license or international driving permit.</li>
        <li>Ensure that the images uploaded clearly show your details to ensure faster verification.</li>
      </ul>
      <div className="grid grid-cols-5 gap-4 mb-6">
        {/* Front License */}
        <div>Front
          <div
            className="flex flex-col justify-center items-center border border-dashed border-gray-300 h-24 rounded cursor-pointer"
            onClick={() => frontLicenseRef.current.click()}
          >
            {/* <span className="text-gray-600 font-semibold mb-2">Front</span> */}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={frontLicenseRef}
              onChange={(e) => handleFileChange(e, 'frontLicense')}
            />
            <div className="text-gray-400">+</div>
            {frontLicenseFileName && (
              <p className="text-sm text-gray-600 mt-2">{frontLicenseFileName}</p>
            )}
          </div>
        </div>
        {/* Back License */}
        <div>Back
          <div
            className="flex flex-col justify-center items-center border border-dashed border-gray-300 h-24 rounded cursor-pointer"
            onClick={() => backLicenseRef.current.click()}
          >
            {/* <span className="text-gray-600 font-semibold mb-2">Back</span> */}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={backLicenseRef}
              onChange={(e) => handleFileChange(e, 'backLicense')}
            />
            <div className="text-gray-400">+</div>
            {backLicenseFileName && (
              <p className="text-sm text-gray-600 mt-2">{backLicenseFileName}</p>
            )}
          </div>
        </div>
      </div>

      {/* Upload ID Section */}
      <h2 className="font-semibold text-lg mt-6 mb-4 text-left">Upload Passport</h2>
      <ul className="list-disc list-inside text-sm text-gray-600 mb-6 text-left">
        <li>Please upload both sides of your original driving license or international driving permit.</li>
        <li>Ensure that the images uploaded clearly show your details to ensure faster verification.</li>
      </ul>
      <div className="grid grid-cols-5 gap-4 mb-6">
        {/* Front ID */}
        <div>Front
          <div
            className="flex flex-col justify-center items-center border border-dashed border-gray-300 h-24 rounded cursor-pointer"
            onClick={() => idFrontRef.current.click()}
          >
            {/* <span className="text-gray-600 font-semibold mb-2">Front</span> */}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={idFrontRef}
              onChange={(e) => handleFileChange(e, 'idFront')}
            />
            <div className="text-gray-400">+</div>
            {idFrontFileName && (
              <p className="text-sm text-gray-600 mt-2">{idFrontFileName}</p>
            )}
          </div>
        </div>
        {/* Back ID */}
        <div>Back
          <div
            className="flex flex-col justify-center items-center border border-dashed border-gray-300 h-24 rounded cursor-pointer"
            onClick={() => idBackRef.current.click()}
          >
            {/* <span className="text-gray-600 font-semibold mb-2">Back</span> */}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={idBackRef}
              onChange={(e) => handleFileChange(e, 'idBack')}
            />
            <div className="text-gray-400">+</div>
            {idBackFileName && (
              <p className="text-sm text-gray-600 mt-2">{idBackFileName}</p>
            )}
          </div>
        </div>
      </div>

      <h2 className="font-semibold text-lg mt-6 mb-4 text-left">Upload Permit</h2>
      <ul className="list-disc list-inside text-sm text-gray-600 mb-6 text-left">
        <li>Please upload both sides of your original driving license or international driving permit.</li>
        <li>Ensure that the images uploaded clearly show your details to ensure faster verification.</li>
      </ul>
      <div className="grid grid-cols-5 gap-4 mb-6">
        {/* Front ID */}
        <div>Front
          <div
            className="flex flex-col justify-center items-center border border-dashed border-gray-300 h-24 rounded cursor-pointer"
            onClick={() => idFrontRef.current.click()}
          >
            {/* <span className="text-gray-600 font-semibold mb-2">Front</span> */}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={idFrontRef}
              onChange={(e) => handleFileChange(e, 'idFront')}
            />
            <div className="text-gray-400">+</div>
            {idFrontFileName && (
              <p className="text-sm text-gray-600 mt-2">{idFrontFileName}</p>
            )}
          </div>
        </div>
        {/* Back ID */}
        <div>Back
          <div
            className="flex flex-col justify-center items-center border border-dashed border-gray-300 h-24 rounded cursor-pointer"
            onClick={() => idBackRef.current.click()}
          >
            {/* <span className="text-gray-600 font-semibold mb-2">Back</span> */}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={idBackRef}
              onChange={(e) => handleFileChange(e, 'idBack')}
            />
            <div className="text-gray-400">+</div>
            {idBackFileName && (
              <p className="text-sm text-gray-600 mt-2">{idBackFileName}</p>
            )}
          </div>
        </div>
      </div>

      {/* Privacy Notice */}
      {/* <p className=" flex justify-start text-sm text-gray-500 mb-6">
        We take our user’s privacy very seriously. To learn more, check out our  <a href="#" className="text-blue-500 underline">Privacy Policy</a>.
      </p> */}
      <p className="flex items-center justify-start text-sm text-gray-500 mb-6">
        <FaSearch className="text-gray-500 mr-2" />
        <span>
          We take our user’s privacy very seriously. To learn more, check out our{' '}
          <a href="#" className="text-blue-500 underline whitespace-nowrap">Privacy Policy</a>.
        </span>
      </p>
      {/* Submit Button */}
      <div className="flex justify-start">
        <button className="bg-[#FF9630] text-white font-semibold py-2 px-12 w-full rounded">
          Submit
        </button>
      </div>

    </div>
  );
}

export default MForeignProfileForm;
